import React, { useState } from "react";
import "./styles.css";

export interface DialogWindowProps {
    displayDialog?: boolean;
    setDisplayDialog: (display: boolean) => void;
    onConfirm?: () => Promise<void> | void;
    title?: string;
    confirmText?: string;
    cancelText?: string;
}

const DialogWindow: React.FC<DialogWindowProps> = ({
    displayDialog = false,
    setDisplayDialog,
    onConfirm,
    title = "",
    confirmText,
    cancelText,
}) => {
    const [isFinishing, setIsFinishing] = useState(false);

    if (!displayDialog) return null;

    const close = () => setDisplayDialog(false);

    const handleConfirm = async () => {
        try {
            setIsFinishing(true);
            await onConfirm?.();
            close();
        } finally {
            setIsFinishing(false);
        }
    };

    return (
        <div className="inv-modal-overlay" onMouseDown={close}>
            <div
                className="inv-modal"
                onMouseDown={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <div className="inv-modal-title">{title}</div>

                <div className="inv-modal-actions1">
                    {confirmText && <button
                        type="button"
                        className="inv-btn"
                        disabled={isFinishing}
                        onClick={handleConfirm}
                    >
                        {confirmText}
                    </button>}

                    {cancelText && <button
                        type="button"
                        className="inv-btn"
                        disabled={isFinishing}
                        onClick={close}
                    >
                        {cancelText}
                    </button>}
                </div>
            </div>
        </div>
    );
};

export default DialogWindow;